<div nz-row>
    <div nz-col nzSpan="6">
        <span class="pageTitle">Sub Departments</span>
    </div>
    <div nz-col nzSpan="8" >
        <div class="search-container" *ngIf="currentUser.Is_Partner">  
            <nz-input-group [nzPrefix]="searchIcon">
                <input
                    nz-input
                    type="text"
                    placeholder="Enter minimum 3 characters to search..."
                    [(ngModel)]="searchText"                    
                    class="search-box"
                />
            </nz-input-group>
            <ng-template #searchIcon>
                <i nz-icon nzType="search" style="color: #0b2d71;"></i>
            </ng-template>   
        </div>
    </div>
    <div nz-col nzSpan="10">
        <div class="button-container" style="display: flex; justify-content: flex-end; align-items: center; float: right;">
            <button nz-button nzType="primary" (click)="showCreateModal()">
                <i nz-icon nzType="file-add" nzTheme="outline"  style="color: white;"></i> Add New Sub-Department
            </button>
        </div>
    </div>
</div> 


<nz-table #subDepartmentTable [nzData]="subDeptMaster" [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="true" >
    <thead>
        <tr>        
            <th *ngFor="let column of listOfColumn"    
                [nzShowSort]="column.allowSorting"
                [nzSortFn]="column.compare" 
                [nzSortPriority]="column.priority" style="padding: 5px;">
                {{ column.title }}
            </th>           
        </tr>        
    </thead>
    <tbody>
        <tr *ngFor="let data of subDepartmentTable.data">
            <td>{{ data.Department_Name}} </td>
            <td>{{ data.Department_Active? 'Active' : 'Inactive'}} </td>
            <td>{{ data.Sub_Dept_Name }}</td>
            <td>{{ data.Manager_Email }}</td>
            <td>{{ data.Supervisor_Email }}</td>
            <td>{{ data.SubDeptStatus }}</td>
            <td>
                <div *ngIf="data.SubDeptStatus == 'Active'" class="button-container" style="display: flex; justify-content: flex-end; align-items: center; float: right;"> 
                    <button  nz-button nzType="primary" [nzSize]="'small'" style="margin-right: 5px;" (click)="showEditModal(data)">
                        <i nz-icon nzType="edit" nzTheme="outline"  style="color: white;"></i> Edit
                    </button>  
                    <button nz-button nzType="primary" [nzSize]="'small'" nzDanger (click)="showDeactivateModal(data)">
                        <i nz-icon nzType="stop"  style="color: white;"></i> De-Activate
                    </button> 
                </div>
            </td>
        </tr>
    </tbody>
</nz-table>


<nz-modal [(nzVisible)]="isVisible" nzTitle="{{ isEditMode ? 'Edit Sub-Department' : 'Add New Sub-Department' }}" (nzOnCancel)="handleCancel()" [nzClosable]="false">
    <div *nzModalContent>
        <form [formGroup]="subDepartmentForm">
            <div class="row form-group">
                <div class="col-md-4">
                    <label class="required">Department<span class="text-danger">*</span></label>
                </div>
                <div class="col-md-8">
                    <nz-select formControlName="department" nzPlaceHolder="Select Department" style="width: 100%;">
                        <nz-option *ngFor="let dept of departmentMaster" [nzValue]="dept.Department_Code" [nzLabel]="dept.Department_Name"></nz-option>
                    </nz-select>
                    <div *ngIf="subDepartmentForm.get('department')?.touched && subDepartmentForm.get('department')?.invalid">
                        <small class="text-danger" *ngIf="subDepartmentForm.get('department')?.errors?.['required']">
                            Department is required.
                        </small>
                    </div>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-md-4">
                    <label class="required">Sub-Department<span class="text-danger">*</span></label>
                </div>
                <div class="col-md-8">
                    <input nz-input formControlName="subDepartmentName" type="text" class="form-control" placeholder="Enter Sub-Department Name" />
                    <div class="text-danger">{{duplicateRecordMessge}}</div>
                    <div *ngIf="subDepartmentForm.get('subDepartmentName')?.touched && subDepartmentForm.get('subDepartmentName')?.invalid">
                        <small class="text-danger" *ngIf="subDepartmentForm.get('subDepartmentName')?.errors?.['required']">
                            Sub-Department Name is required.
                        </small>
                        <small class="text-danger" *ngIf="subDepartmentForm.get('subDepartmentName')?.errors?.['maxlength']">
                            Sub-Department Name cannot exceed 50 characters.
                        </small>
                    </div>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-md-4">
                    <label class="required">Manager Email<span class="text-danger">*</span></label>
                </div>
                <div class="col-md-8">
                    <input nz-input formControlName="managerEmail" type="email" class="form-control" placeholder="Enter Manager Email" />
                    <div *ngIf="subDepartmentForm.get('managerEmail')?.touched && subDepartmentForm.get('managerEmail')?.invalid">
                        <small class="text-danger" *ngIf="subDepartmentForm.get('managerEmail')?.errors?.['required']">
                            Manager Email is required.
                        </small>
                        <small class="text-danger" *ngIf="subDepartmentForm.get('managerEmail')?.errors?.['email']">
                            Invalid email format.
                        </small>
                    </div>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-md-4">
                    <label class="required">Supervisor Email<span class="text-danger">*</span></label>
                </div>
                <div class="col-md-8">
                    <input nz-input formControlName="supervisorEmail" type="email" class="form-control" placeholder="Enter Supervisor Email" />
                    <div *ngIf="subDepartmentForm.get('supervisorEmail')?.touched && subDepartmentForm.get('supervisorEmail')?.invalid">
                        <small class="text-danger" *ngIf="subDepartmentForm.get('supervisorEmail')?.errors?.['required']">
                            Supervisor Email is required.
                        </small>
                        <small class="text-danger" *ngIf="subDepartmentForm.get('supervisorEmail')?.errors?.['email']">
                            Invalid email format.
                        </small>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div *nzModalFooter>
        <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
        <button nz-button nzType="primary" [disabled]="subDepartmentForm.invalid" (click)="handleOk()" [nzLoading]="isConfirmLoading">
            {{ isEditMode ? 'Update' : 'Create' }}
        </button>
    </div>
</nz-modal>